import {
    getStowAssociateMetrics,
    getStowBinMetrics,
    getStowPackageMetrics,
    getNodeResourceData,
    getStowBinMetricsForStowV2
} from "../resources/StowResource";
import {getInductPackageMetrics} from "../resources/InductResource";
import {publishCount, publishTime} from "../MetricUtility";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, FALSE, TOTAL} from "../constants";
import {AssociateMetric, InductPackageMetric, StowPackageMetric, Resource, BinMetric} from "../enums";

export const LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN = "LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN";
export const LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER = "LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER";
export const LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER = "LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_BIN_METRICS_FOR_CLUSTER = "LOAD_STOW_BIN_METRICS_FOR_CLUSTER";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER = "LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_BIN_METRICS_FOR_NODE = "LOAD_STOW_BIN_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER = "LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER";
export const LOAD_STOW_PACKAGE_METRICS_FOR_NODE = "LOAD_STOW_PACKAGE_METRICS_FOR_NODE";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE = "LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";
export const LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE = "LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE";
export const LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER = "LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER";

export const LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2 = "LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2";

const metricProcessName = "SCC_STOW_CLUSTER";

const loadMetricsForClusterCallBegin = () => ({
    type: LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN
});

const loadStowBinMetricsForClusterForStowV2 = (stowBinMetricsMapForStowV2) => ({
   type : LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2,
   stowBinMetricsMapForStowV2
});
const loadMinOfWorkMetricsForCluster = (minOfWorkMetricsMap) => ({
    type: LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER,
    minOfWorkMetricsMap
});

const loadStowPackageMetricsForCluster = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,
    stowPackageMetricsMap
});

const loadNodeResourcesDataForCluster = (nodeResourceData) =>({
    type: LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER,
    nodeResourceData
});

const loadStowBinMetricsForCluster = (stowBinMetricsMap) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_CLUSTER,
    stowBinMetricsMap
});

const loadStowBinMetricsForNode = (totalStowBinMetrics) => ({
    type: LOAD_STOW_BIN_METRICS_FOR_NODE,
    totalStowBinMetrics
});

const loadInductPackageMetricsForCluster = (inductPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,
    inductPackageMetricsMap
});

const loadStowAssociateMetricsForCluster = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,
    stowAssociateMetricsMap
});

const loadStowPackageMetricsForNode = (totalStowPackageMetrics) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    totalStowPackageMetrics
});

const loadInductPackageMetricsForNode = (totalInductPackageMetrics) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    totalInductPackageMetrics
});

const loadStowAssociateMetricsForNode = (totalStowAssociateMetrics) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    totalStowAssociateMetrics
});

const loadMetricsForClusterCallFailure = () => ({
    type: LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE
});

export const getStowPackageMetricsForCluster = (isADTAVisibilityEnabled, isDRSStowVisibilityEnabled, nodeId, cycles, cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowPackageMetrics";
    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.STOW_VS_PLAN,
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ],
        isAggregationRequired: true
    }
    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    if (isADTAVisibilityEnabled) {
        request.metrics.push(StowPackageMetric.CURRENT_STOW_BUFFERED_COUNT)
        request.metrics.push(StowPackageMetric.CURRENT_MFR_JACKPOT_BUFFERED_COUNT)
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    function getStowPackageMetricsForNode(stowPackageMetricsMap) {
        return {Total: stowPackageMetricsMap[TOTAL]}
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            stowPackageMetricsMap["A"] = {
                "displayLabel": "A1.1A",
                "plannedPackages": 5,
                "stowedPackages": 2,
                "currentInductedPackages": 4,
            }
            stowPackageMetricsMap["B"] = {
                "displayLabel": "A1.1B",
                "plannedPackages": 6,
                "stowedPackages": 4,
                "currentInductedPackages": 5,
            }
            console.log("stowPackageMetricsMap Cluster: " + JSON.stringify(stowPackageMetricsMap));
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));
                removeUnwantedClusters(stowPackageMetricsMap);
                dispatch(loadStowPackageMetricsForCluster(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getNodeResourceDataForCluster = (nodeId, nodeResourceType) => {
    const metricName = "getNodeResourceData";
    const request = {
        nodeId: nodeId,
        nodeResourceType :nodeResourceType

    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const nodeResources = await getNodeResourceData(request);
            if (nodeResources) {
                dispatch(loadNodeResourcesDataForCluster(nodeResources));
                publishTime(metricProcessName, metricName, startTime);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
};

export const getMinOfWorkMetricsForCluster = (nodeId, isDRSStowVisibilityEnabled, cycles, cycleIds) => {

    const metricName = "getMinOfWorkMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.MINUTES_OF_WORK,
            StowPackageMetric.LAST_FIFTEEN_MINUTE_STOW_RATE,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ],
        isAggregationRequired: true
    }

    if (!isDRSStowVisibilityEnabled) {
        request.filters["DRS"] = [FALSE]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const minOfWorkMetricsMap = await getStowPackageMetrics(request);
            if (minOfWorkMetricsMap) {
                minOfWorkMetricsMap["totalMinOfWork"] = minOfWorkMetricsMap["Total"]["minutesOfWork"];
                removeUnwantedClusters(minOfWorkMetricsMap);
                dispatch(loadMinOfWorkMetricsForCluster(minOfWorkMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBinMetricsForClusterforStowV2 = (nodeId, cycles, cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled, isStowBreakdownV2Enabled) => {

    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetricsForStowV2(request);
            if (stowBinMetricsMap) {
                removeUnwantedClusters(stowBinMetricsMap);
                dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));
                dispatch(loadStowBinMetricsForClusterForStowV2(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBinMetricsForCluster = (nodeId, cycles, cycleIds, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length && !isCPTFilterEnabled) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetrics(request);
            if (stowBinMetricsMap) {
                removeUnwantedClusters(stowBinMetricsMap);
                dispatch(loadStowBinMetricsForNode(getTotalMetrics(stowBinMetricsMap)));
                dispatch(loadStowBinMetricsForCluster(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForCluster = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        filters: {
        },
        groupBy: "Cluster",
        metricList: [InductPackageMetric.RECEIVED]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters["Cycle"] = cycles
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                removeUnwantedClusters(inductPackageMetricsMap);
                dispatch(loadInductPackageMetricsForNode(getTotalMetrics(inductPackageMetricsMap)));
                dispatch(loadInductPackageMetricsForCluster(inductPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowAssociateMetricsForCluster = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {

    const metricName = "getStowAssociateMetrics";

    const request = {
        groupBy: Resource.CLUSTER,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters[CYCLE] = cycles;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const startTime = Date.now();
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMap) {
                removeUnwantedClusters(stowAssociateMetricsMap);
                dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));
                dispatch(loadStowAssociateMetricsForCluster(stowAssociateMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForClusterCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForNode = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {
    const request = {
        nodeId: nodeId,
        groupBy: "Node",
        metricList: ["INDUCTED_AT_STATION", "PENDING_INDUCT"]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters = {"Cycle": cycles}
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            replaceNodeByTotal(inductPackageMetricsMap, nodeId);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForNode(inductPackageMetricsMap));
            } else {
                dispatch(loadMetricsForClusterCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
        }
    }
}

export const getStowAssociateMetricsForNode = (nodeId, cycles, CPTIds, filterIdentifier, isCPTFilterEnabled) => {
    const request = {
        groupBy: "NODE",
        filters: {
            'NODE': [nodeId]
        },
        metrics: ["ACTIVE_ASSOCIATE_COUNT", "INACTIVE_ASSOCIATE_COUNT"]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length && !isCPTFilterEnabled) {
        request.filters["CYCLE"] = cycles;
    }

    if (CPTIds.length && isCPTFilterEnabled) {
        request.filters[[filterIdentifier]] = CPTIds;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForClusterCallBegin());
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            replaceNodeByTotal(stowAssociateMetricsMap, nodeId);
            if (stowAssociateMetricsMap) {
                dispatch(loadStowAssociateMetricsForNode(stowAssociateMetricsMap));
            } else {
                dispatch(loadMetricsForClusterCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForClusterCallFailure());
        }
    }
}

function replaceNodeByTotal(metricsMap, nodeId) {
    metricsMap["Total"] = metricsMap[nodeId];
    delete metricsMap[nodeId];
}

function getTotalMetrics(groupedMetricsMap) {
    const totalCluster = {};
    for (const cluster in groupedMetricsMap) {
        const metricsMap = groupedMetricsMap[cluster];

        for (const metric in metricsMap) {
            if (!totalCluster[metric]) {
                totalCluster[metric] = metricsMap[metric];
            } else {
                totalCluster[metric] = +totalCluster[metric] + +metricsMap[metric];
            }
        }
    }

    return {Total: totalCluster};
}

function removeUnwantedClusters(metricsMap) {
    delete metricsMap[TOTAL];
}


// WEBPACK FOOTER //
// ./src/actions/ClusterActionsV2.js